const view = /*html*/ `

    <style>
        .apexcharts-xcrosshairs,.apexcharts-ycrosshairs {
            cursor: pointer !important;
        }

        .apexcharts-tooltip, .apexcharts-active, .apexcharts-xaxistooltip {
            cursor: pointer !important;
        }
    </style>
    
    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl">
    <!--begin::Navbar-->
    <div class="profile-ban">
    </div>    

    <div class="card mb-5 mb-xxl-8">
        <div class="card-body pt-9 rounded rounded-bottom-0 pb-0 bgi-position-x-end bgi-position-y-center min-h-200px" style="background-image:url('assets/media/profile/profile_header.png');">
            <!--begin::Details-->
            <div class="d-flex flex-wrap flex-sm-nowrap">
                <!--begin: Pic-->
                <div class="me-7 mb-4">
                    <div class="symbol symbol-100px symbol-lg-125px symbol-fixed position-relative">
                        <img class="profile-user-avatar" src="assets/media/avatars/default.jpg" alt="image" />
                        <!--<div class="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px"></div>-->
                        <div class="profile-online-badge symbol-badge online-badge start-100 top-100 border-3 border-body h-20px w-20px ms-n4 mt-n4"></div>
                    </div>
                </div>
                <!--end::Pic-->
                <!--begin::Info-->
                <div class="flex-grow-1">
                    
                    <!--begin::Stats-->
                    <div class="d-flex flex-wrap flex-stack">
                        <!--begin::Wrapper-->
                        <div class="d-flex flex-column flex-grow-1 pe-8">
                            <!--begin::Stats-->
                            <div class="d-flex flex-wrap">
                                <!--begin::Stat-->
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <!--begin::Number-->
                                    <div class="d-flex align-items-center gap-2">                                        
                                        <img class="profile-flag" src="assets/media/flags/.gif"/><div class="fs-6 profile-country">Unknwon</div>
                                    </div>
                                    <!--end::Number-->
                                    <!--begin::Label-->
                                    <div class="fw-bold fs-7 text-gray-500">
                                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr066.svg-->                                        
                                        <i class="fad fa-map-marker-alt text-success me-2"></i><span class="text-uppercase" data-i18n="user.from">From</span>
                                    </div>
                                    <!--end::Label-->
                                </div>
                                <!--end::Stat-->

                                <!--begin::Stat-->
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <!--begin::Number-->
                                    <div class="d-flex align-items-center fs-6">
                                        <span class="profile-created text-capitalize"></span>
                                    </div>
                                    <!--end::Number-->
                                    <!--begin::Label-->
                                    <div class="fw-bold fs-7 text-gray-500">
                                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr066.svg-->                                        
                                        <i class="fad fa-calendar-plus text-success me-2"></i><span class="text-uppercase" data-i18n="user.joined">Joined</span>
                                    </div>
                                    <!--end::Label-->
                                </div>
                                <!--end::Stat-->

                                <!--begin::Stat-->
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <!--begin::Number-->
                                    <div class="d-flex align-items-center fs-6">
                                        <span class="profile-lastlogin text-capitalize"></span>
                                    </div>
                                    <!--end::Number-->
                                    <!--begin::Label-->
                                    <div class="fw-bold fs-7 text-gray-500">
                                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr066.svg-->                                        
                                        <i class="fad fa-clock text-success me-2"></i><span class="text-uppercase" data-i18n="user.lastseen">Last Seen</span>
                                    </div>
                                    <!--end::Label-->
                                </div>
                                <!--end::Stat-->

                                <!--begin::Stat-->
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <!--begin::Number-->
                                    <div class="d-flex align-items-center fs-6">
                                        <span class="profile-steamid text-capitalize"></span>
                                    </div>
                                    <!--end::Number-->
                                    <!--begin::Label-->
                                    <div class="fw-bold fs-7 text-gray-500">
                                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr066.svg-->                                        
                                        <i class="fab fa-steam text-success me-2 opacity-75"></i><span class="text-uppercase">Steamid</span>
                                    </div>
                                    <!--end::Label-->
                                </div>
                                <!--end::Stat-->
                                
                            </div>
                            <!--end::Stats-->
                        </div>
                        <!--end::Wrapper-->
                       
                        <!--begin::Actions-->
                        <div class="d-flex profile-actions  align-self-start">
                            
                        </div>
                        <!--end::Actions-->
                        
                    </div>
                    <!--end::Stats-->

                    <!--begin::Title-->
                    <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
                        <!--begin::User-->
                        <div class="d-flex flex-column"> 
                            <!--begin::Name-->
                            <div class="d-flex align-items-center">
                                <span class="text-gray-900 fs-2x fw-bolder me-1 profile-user-nick"></span>
                            </div>
                            <!--end::Name-->
                            <!--begin::Info-->
                            <!--<div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">                                
                            </div>-->
                            <!--end::Info-->
                        </div>
                        <!--end::User-->
                        <div class="d-flex">                            
                            <a class="text-hover-gray-900 profile-user-steam-link" data-toggle="tooltip"  target="_blank">
                                <i class="fab fa-steam fs-1 text-gray-700"></i>
                            </a>
                        </div>
                    </div>
                    <!--end::Title-->
                </div>
                <!--end::Info-->
            </div>
            <!--end::Details-->        
        </div>

        <div class="card-body p-0 rounded rounded-top-0" style="background-color: #1B1B1B">
            <!--begin::Navs-->
            <div class="d-flex flex-row justify-content-between min-h-50px">
                <div class="d-grid">
                    <ul class="nav nav-tabs profile-nav-tabs text-nowrap border-bottom-0 gap-2">
                        <li class="nav-item flex-grow-1">
                            <a class="nav-link justify-content-center h-100 btn btn-color-gray-700 btn-active-primary btn-active-color-zblack rounded-top-0 fs-6 profile-pill d-flex align-items-center" data-bs-toggle="tab" data-bs-target="#profile-tab-overview" tab="overview" data-navigo href="#"><i class="fal fa-user"></i> <span data-i18n="user.nav_overview">Overview</span></a>
                        </li>
                        <li class="nav-item  flex-grow-1">
                            <a class="nav-link  justify-content-center h-100 btn btn-color-gray-700 btn-active-primary btn-active-color-zblack rounded-top-0 fs-6 profile-pill d-flex align-items-center" data-bs-toggle="tab" data-bs-target="#profile-tab-statistics" tab="stats" data-navigo href="#"><i class="fal fa-share-alt"></i> <span data-i18n="user.nav_stats">Statistics</span></a>
                        </li>
                        <li class="nav-item  flex-grow-1">
                            <a class="nav-link justify-content-center h-100 btn btn-color-gray-700 btn-active-primary btn-active-color-zblack rounded-top-0 fs-6 profile-pill d-flex align-items-center" data-bs-toggle="tab" data-bs-target="#profile-tab-matches" tab="matches" data-navigo href="#"><i class="fal fa-swords"></i> <span data-i18n="user.nav_matches">Matches</span></a>
                        </li>
                        <li class="nav-item  flex-grow-1">
                            <a class="nav-link justify-content-center h-100 btn btn-color-gray-700 btn-active-primary btn-active-color-zblack rounded-top-0 fs-6 profile-pill d-flex align-items-center" data-bs-toggle="tab" data-bs-target="#profile-tab-highlights" tab="highlights" data-navigo href="#"><i class="fal fa-sunglasses"></i> <span data-i18n="user.nav_high">Highlights</span></a>
                        </li>
                        <li class="nav-item  flex-grow-1">
                            <a class="nav-link justify-content-center h-100 btn btn-color-gray-700 btn-active-primary btn-active-color-zblack rounded-top-0 fs-6 profile-pill d-flex align-items-center" data-bs-toggle="tab" data-bs-target="#profile-tab-friends" tab="friends" data-navigo href="#"><i class="fal fa-user-friends"></i> <span data-i18n="user.nav_friends">Friends</span></a>
                        </li>
                        <li class="nav-item  flex-grow-1">
                            <a class="nav-link justify-content-center h-100 btn btn-color-gray-700 btn-active-primary btn-active-color-zblack rounded-top-0 fs-6 profile-pill d-flex align-items-center" data-bs-toggle="tab" data-bs-target="#profile-tab-achievements" tab="achievements" data-navigo href="#"><i class="fal fa-medal"></i> <span data-i18n="user.nav_ach">Achievements</span></a>
                        </li>
                        <li class="nav-item  flex-grow-1">
                            <a class="nav-link justify-content-center h-100 btn btn-color-gray-700 btn-active-primary btn-active-color-zblack rounded-top-0 fs-6 profile-pill d-flex align-items-center" data-bs-toggle="tab" data-bs-target="#profile-tab-records" tab="records" data-navigo href="#"><i class="fal fa-star-exclamation"></i> <span data-i18n="user.nav_rec">Records</span></a>
                        </li>
                        <li class="nav-item  flex-grow-1">
                            <a class="nav-link justify-content-center h-100 btn btn-color-gray-700 btn-active-primary btn-active-color-zblack rounded-top-0 fs-6 profile-pill d-flex align-items-center" data-bs-toggle="tab" data-bs-target="#profile-tab-bans" tab="bans" data-navigo href="#"><i class="fal fa-ban"></i> <span data-i18n="user.nav_bans">Bans</span></a>
                        </li>
                    </ul>
                </div>                
            </div>
            <!--begin::Navs-->
        </div>
    </div>
    <!--end::Navbar-->
    <!--begin::Row-->
    <div class="row">
        <div class="tab-content profile-tab-content">
            <div class="tab-pane main-tab fade" id="profile-tab-overview" role="tabpanel">
                <div class="row">                    
                    <div class="col-lg-8 col-xl-9">
                        
                        <div class="card mb-5 mb-xl-10">
                            <div class="card-header border-0">
                                <!--begin::Heading-->
                                <div class="card-title">
                                    <h4 class="d-flex align-items-center"><i class="fal fa-analytics text-primary align-self-center me-3"></i><span data-i18n="user.overview_mainstats">Main Stats</span></h4>
                                </div>
                                <!--end::Heading-->
                        
                                <!--begin::Toolbar-->
                                <div class="card-toolbar">                        
                                    <a data-navigo href="#" class="btn btn-sm btn-light-primary my-1 profile-quicklink" tab="stats" data-i18n="user.nav_viewall">
                                        View All
                                    </a>
                                </div>
                                <!--end::Toolbar-->
                            </div>
                            <!--begin::Body-->
                            <div class="card-body pt-2">

                                <div class="card card-flush shadow-none mb-6">
                                    <div class="card-body p-0">
                                        <div class="row">
                                            <!--begin::Col-->
                                            <div class="col">
                                                <div class="card flex-center min-w-125px my-3 p-4 bg-gray-200">
                                                    <span class="fs-lg-2 fw-bolder d-flex justify-content-center">
                                                        <span class="overview-rating" data-kt-countup="true" data-kt-countup-value="0" data-kt-countup-separator="">0</span>
                                                    </span>
                                                    <span class="fs-6 fw-semibold text-primary px-2" data-toggle="tooltip" title="Glicko earned" data-i18n="[title]stats.trating;[data-bs-original-title]stats.trating">RATING</span>
                                                </div>
                                            </div>
                                            <!--end::Col-->

                                            <div class="col">
                                                <div class="card flex-center min-w-125px my-3 p-4 bg-gray-200">
                                                    <span class="fs-lg-2 fw-bolder d-flex justify-content-center">
                                                        <span class="overview-global-ranking" data-kt-countup="true" data-kt-countup-value="0" data-kt-countup-separator="">-</span>
                                                    </span>
                                                    <span class="fs-6 fw-semibold text-primary px-2" data-toggle="tooltip" title="" data-i18n="">Global Ranking</span>
                                                </div>
                                            </div>

                                            <div class="col">
                                                <div class="card flex-center min-w-125px my-3 p-4 bg-gray-200">
                                                    <span class="fs-lg-2 fw-bolder d-flex justify-content-center">
                                                        <span class="overview-country-ranking" data-kt-countup="true" data-kt-countup-value="0" data-kt-countup-separator="">-</span>
                                                    </span>
                                                    <span><span class="fs-6 fw-semibold text-primary px-2" data-toggle="tooltip" title="" data-i18n="">Ranking</span> <span class="overview-country-ranking-code"></span></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--begin::Body-->
                                    <div class="card-body p-0">

                                        <!--begin::Stats-->
                                        <div class="row">
                                            <!--begin::Col-->
                                            <!--<div class="col">
                                                <div class="card card-dashed border-primary flex-center min-w-125px my-3 p-4" style="background-color:#1b1b1b">
                                                    <span class="fs-lg-2 fw-bolder d-flex justify-content-center">
                                                        <span class="overview-rating" data-kt-countup="true" data-kt-countup-value="0" data-kt-countup-separator="">0</span>
                                                    </span>
                                                    <span class="fs-6 fw-semibold text-primary px-2" data-toggle="tooltip" title="Glicko earned" data-i18n="[title]stats.trating;[data-bs-original-title]stats.trating">RATING</span>
                                                </div>
                                            </div>-->
                                            <!--end::Col-->

                                            <!--begin::Col-->
                                            <div class="col">
                                                <div class="card card-dashed flex-center min-w-125px my-3 p-4" style="background-color:#1b1b1b">
                                                    <span class="fs-lg-2 fw-bolder d-flex justify-content-center">
                                                        <span class="overview-kdr" data-kt-countup="true" data-kt-countup-decimal-places="2" data-kt-countup-value="0.0">0</span>
                                                    </span>
                                                    <span class="fs-6 fw-semibold text-gray-600 px-2" data-toggle="tooltip" title="Kill/Death Ratio" data-i18n="[title]stats.tkdr;[data-bs-original-title]stats.tkdr">KDR</span>
                                                </div>
                                            </div>
                                            <!--end::Col-->

                                            
                                            <!--begin::Col-->
                                            <div class="col">
                                                <div class="card card-dashed flex-center min-w-125px my-3 p-4" style="background-color:#1b1b1b">
                                                    <span class="fs-lg-2 fw-bolder d-flex justify-content-center">
                                                        <span class="overview-kpr" data-kt-countup="true" data-kt-countup-decimal-places="2" data-kt-countup-value="0.0">0</span>
                                                    </span>
                                                    <span class="fs-6 fw-semibold text-gray-600 px-2" data-toggle="tooltip" title="Kills per Round" data-i18n="[title]stats.tkpr;[data-bs-original-title]stats.tkpr">KPR</span>
                                                </div>
                                            </div>
                                            <!--end::Col-->  

                                            <!--begin::Col-->
                                            <div class="col">
                                                <div class="card card-dashed flex-center min-w-125px my-3 p-4" style="background-color:#1b1b1b">
                                                    <span class="fs-lg-2 fw-bolder d-flex justify-content-center">
                                                        <span class="overview-adr" data-kt-countup="true" data-kt-countup-decimal-places="2" data-kt-countup-value="0.00">0.00</span>
                                                    </span>
                                                    <span class="fs-6 fw-semibold text-gray-600 px-2" data-toggle="tooltip" title="Average Damage per Round" data-i18n="[title]stats.tadr;[data-bs-original-title]stats.tadr">ADR</span>
                                                </div>
                                            </div>
                                            <!--end::Col-->
                                            
                                            <!--begin::Col-->
                                            <div class="col">
                                                <div class="card card-dashed flex-center min-w-125px my-3 p-4" style="background-color:#1b1b1b">
                                                    <span class="fs-lg-2 fw-bolder d-flex justify-content-center">
                                                        <span class="overview-hsp" data-kt-countup="true" data-kt-countup-decimal-places="2" data-kt-countup-value="0.00" data-kt-countup-suffix="%">0</span>
                                                    </span>
                                                    <span class="fs-6 fw-semibold text-gray-600 px-2" data-toggle="tooltip" title="Headshots Percentage" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HSP</span>
                                                </div>
                                            </div>
                                            <!--end::Col-->                                
                                        </div>
                                        <!--end::Stats-->
                                        
                                    </div>
                                </div>


                                <!--begin::Overview-->
                                <div class="row">
                                    <!--begin::Col-->
                                    <div class="col-xl-4 mb-sm-0 mb-5 mb-xl-0">
                                        <div class="card card-flush shadow-none" style="background-color:#1b1b1b">
                                            <!--begin::Body-->
                                            <div class="card-body mb-3">
                                                <div class="d-flex justify-content-center align-items-center py-1">
                                                    <div class="symbol symbol-75px">
                                                        <img class="overview-rank-img" src="assets/media/ranks/rank_0.png">
                                                    </div>                                                    
                                                </div>                                                                                            

                                                <div class="d-flex flex-column w-100 mt-10">
                                                    
                                                    <div class="d-flex flex-row justify-content-between">
                                                        <span class="text-dark me-2 fw-bold pb-3">
                                                            <span data-i18n="user.level">Level</span> <span class="overview-rank-level">0</span>
                                                        </span>

                                                        <div>
                                                        <span class="text-dark fw-bold pb-3 fs-5">
                                                            <span class="overview-rating">-</span>
                                                        </span>
                                                        /
                                                        <span class="text-gray-700 fw-bold pb-3 fs-7 overview-rating-next">
                                                            800
                                                        </span>
                                                        </div>
                                                    </div>

                                                    <div class="progress h-5px w-100 bg-primary bg-opacity-50">
                                                        <div class="progress-bar bg-primary overview-progress" role="progressbar" style="width: 89%" aria-valuenow="89" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--end:: Body-->
                                        </div>
                                    </div>
                                    <!--end::Col-->
                        
                                    <!--begin::Col-->
                                    <div class="col-xl-8 mb-sm-5 mb-0 mb-xl-0">
                                        <div class="card card-flush shadow-none" style="background-color:#1b1b1b">
                                            <!--begin::Body-->
                                            <div class="card-body my-3">
                                                <div class="d-flex flex-row justify-content-between">
                                                    <div class="d-flex flex-column pe-6 gap-6 justify-content-center">
                                                        <div class="text-center">
                                                            <i class="fal fa-swords fs-3tx text-info"></i>
                                                        </div>

                                                        <div class="d-flex flex-column gap-0 justify-content-center">
                                                            <h4 class="mb-0 text-center overview-matches">0</h4>
                                                            <span class="text-gray-600 fs-7 text-uppercase text-center" data-i18n="user.nav_matches">Matches</span>
                                                        </div>                                                        
                                                    </div>

                                                    <div class="d-flex flex-column gap-3 flex-grow-1 flex-shrink-1 mw-325px">
                                                        <div class="w-100">
                                                            <div class="d-flex flex-column w-100">
                                                                <div class="d-flex justify-content-between px-1 mb-1">
                                                                    <div class="d-flex gap-2">
                                                                        <span class="align-self-end text-uppercase fs-8 text-gray-600" data-i18n="user.won">Won</span>
                                                                        <h3 class="mb-0 align-self-end text-white fs-6 overview-matches-won">0</h3>
                                                                    </div>

                                                                    <div class="d-flex gap-2">
                                                                        <h3 class="mb-0 align-self-end text-white fs-6 overview-matches-lose">0</h3>
                                                                        <span class="align-self-end text-uppercase text-gray-600 fs-8" data-i18n="user.lose">Lose</span>                                                                        
                                                                    </div>
                                                                </div>

                                                                <div class="p-1 d-flex flex-row gap-0 rounded bg-light w-100">
                                                                    <div class="progress h-5px overview-progress-won" data-toggle="tooltip" title="" style="width:50%">
                                                                        <div class="progress-bar bg-success w-100" role="progressbar"></div>
                                                                    </div>
                                                                    <div class="progress h-5px overview-progress-lose" data-toggle="tooltip" title="" style="width:50%">
                                                                        <div class="progress-bar bg-danger w-100" role="progressbar"></div>
                                                                    </div>
                                                                </div>

                                                                <div class="d-flex justify-content-between px-1 mt-2">
                                                                    <div class="d-flex gap-2">
                                                                        <h6 class="mb-0 align-self-end text-white overview-matches-won-percent">50%</h6>
                                                                    </div>

                                                                    <div class="d-flex gap-2">
                                                                        <h6 class="mb-0 align-self-end text-white overview-matches-lose-percent">50%</h6>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <!--end::Col-->
                                </div>
                                <!--end::Overview-->

                                
                                                                                                                                            
                            </div>
                            <!--end::Body-->
                        </div>

                        <div class="card mb-5 mb-xl-10">
                            <div class="card-header border-0">
                                <!--begin::Heading-->
                                <div class="card-title">
                                    <h4 class="d-flex align-items-center"><i class="fal fa-swords text-primary align-self-center me-3"></i><span data-i18n="user.overview_latestmatches">Latest Matches</span></h4>
                                </div>
                                <!--end::Heading-->
                        
                                <!--begin::Toolbar-->
                                <div class="card-toolbar">                        
                                    <a data-navigo href="#" class="btn btn-sm btn-light-primary my-1 profile-quicklink" tab="matches" data-i18n="user.nav_viewall">
                                        View All
                                    </a>
                                </div>
                                <!--end::Toolbar-->
                            </div>
                            <!--begin::Body-->
                            <div class="card-body pt-2 overview-match-list">
                                                                
                            </div>
                        </div>

                    </div>

                    <div class="col-lg-4 col-xl-3">

                        <div class="card mb-5 mb-xl-10">
                            <div class="card-header border-0">
                                <!--begin::Heading-->
                                <div class="card-title">
                                    <h4 class="d-flex align-items-center"><i class="fal fa-eye text-primary align-self-center me-3"></i><span data-i18n="user.nav_visitors">Recent Curious</span></h4>
                                </div>
                                <!--end::Heading-->
                        
                                <!--begin::Toolbar-->
                                <div class="card-toolbar">                        
                                    <span class="badge badge-sm flex-shrink-0 align-self-center text-gray-200 mb-2 mb-sm-0 bg-primary"><span class="profile-views">0</span> <span>Views</span></span>
                                </div>
                                <!--end::Toolbar-->
                            </div>
                            <!--begin::Body-->
                            <div class="card-body pt-2 px-4 profile-tab-overview-visitors">
                                
                                <div class="text-center profile-tab-overview-visitors-none">
                                    <div class="pt-15 pb-6">
                                        <i class="fad fa-eye fs-3x text-primary opacity-75"></i>                                                            
                                    </div>
                                    
                                    <div class="fw-bold pb-15">
                                        <h3 class="text-gray-600 fs-5 mb-2" data-i18n="user.no_visitors">No visitors yet</h3>
                                        <div class="text-muted fs-7" data-i18n="user.no_visitors_msg">You are the first.</div>
                                    </div>                                    
                                </div>

                            </div>
                        </div>

                        <div class="card mb-5 mb-xl-10">
                            <div class="card-header border-0">
                                <!--begin::Heading-->
                                <div class="card-title">
                                    <h4 class="d-flex align-items-center"><i class="fal fa-user-friends text-primary align-self-center me-3"></i><span data-i18n="user.nav_friends">Friends</span></h4>
                                </div>
                                <!--end::Heading-->
                        
                                <!--begin::Toolbar-->
                                <div class="card-toolbar">                        
                                    <a data-navigo href="#" class="btn btn-sm btn-light-primary my-1 profile-quicklink" tab="friends" data-i18n="user.nav_viewall">
                                        View All
                                    </a>
                                </div>
                                <!--end::Toolbar-->
                            </div>
                            <!--begin::Body-->
                            <div class="card-body pt-2 px-4 profile-tab-overview-flist"> 
                            
                                <div class="text-center">                                    
                                    <div class="pt-15 pb-6">
                                        <i class="fad fa-user-friends fs-3x text-primary opacity-75"></i>                                                            
                                    </div>
                                    
                                    <div class="fw-bold pb-15">
                                        <h3 class="text-gray-600 fs-5 mb-2" data-i18n="user.no_friends"></h3>
                                        <div class="text-muted fs-7" data-i18n="user.no_friends_msg"></div>
                                    </div>                                    
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="tab-pane main-tab fade" id="profile-tab-statistics" role="tabpanel">
                <div class="d-flex flex-column flex-md-row">
                    <ul class="nav nav-pills nav-pills-custom mb-3 flex-row flex-md-column" role="tablist">
                        <!--begin::Item--> 
                        <li class="nav-item mb-3 me-3 me-lg-6" role="presentation">
                            <!--begin::Link--> 
                            <a class="nav-link profile-stats-pill btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-85px pt-5 pb-2" id="kt_stats_widget_16_tab_link_1" data-bs-toggle="pill" data-bs-target="#profile-statistics-tab-overall" aria-selected="true" role="tab" tab="overall" href="#" data-navigo>
                                <!--begin::Icon-->
                                <div class="nav-icon mb-3">
                                    <i class="fad fa-ballot fs-1 pe-0"></i>                                                      
                                </div>
                                <!--end::Icon-->
                                
                                <!--begin::Title-->
                                <span class="nav-text text-gray-800 fw-bold fs-7 lh-1" data-i18n="user.stats_overall">Overall</span>
                                <!--end::Title-->
                                
                                <!--begin::Bullet-->
                                <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                                <!--end::Bullet-->
                            </a>
                            <!--end::Link-->
                        </li>
                        <!--end::Item-->

                        <!--begin::Item-->
                        <li class="nav-item mb-3 me-3 me-lg-6" role="presentation">
                            <!--begin::Link-->
                            <a class="nav-link profile-stats-pill btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-85px pt-5 pb-2" id="kt_stats_widget_16_tab_link_5" data-bs-toggle="pill" data-bs-target="#profile-statistics-tab-rating" aria-selected="false" role="tab" tab="rating" href="#" data-navigo>
                                <!--begin::Icon-->
                                <div class="nav-icon mb-3">                                    
                                    <i class="fad fa-user-chart fs-1 pe-0"></i>
                                </div>
                                <!--end::Icon-->
                                
                                <!--begin::Title-->
                                <span class="nav-text text-gray-800 fw-bold fs-7 lh-1" data-i18n="user.stats_rating">Rating</span>
                                <!--end::Title-->
                                
                                <!--begin::Bullet-->
                                <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                                <!--end::Bullet-->
                            </a>
                            <!--end::Link-->
                        </li>
                        <!--end::Item-->

                        <!--begin::Item-->
                        <li class="nav-item mb-3 me-3 me-lg-6" role="presentation">
                            <!--begin::Link-->
                            <a class="nav-link profile-stats-pill btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-85px pt-5 pb-2" id="kt_stats_widget_16_tab_link_2" data-bs-toggle="pill" data-bs-target="#profile-statistics-tab-weapons" aria-selected="false" role="tab" tab="weapons" href="#" data-navigo>
                                <!--begin::Icon-->
                                <div class="nav-icon mb-3">
                                    <i class="fad fa-axe fs-1 pe-0"></i>                                                      
                                </div>
                                <!--end::Icon-->
                                
                                <!--begin::Title-->
                                <span class="nav-text text-gray-800 fw-bold fs-7 lh-1" data-i18n="user.stats_weapons">Weapons</span>
                                <!--end::Title-->
                                
                                <!--begin::Bullet-->
                                <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                                <!--end::Bullet-->
                            </a>
                            <!--end::Link-->
                        </li>
                        <!--end::Item-->

                        <!--begin::Item-->
                        <li class="nav-item mb-3 me-3 me-lg-6" role="presentation">
                            <!--begin::Link-->
                            <a class="nav-link profile-stats-pill btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-85px pt-5 pb-2" id="kt_stats_widget_16_tab_link_3" data-bs-toggle="pill" data-bs-target="#profile-statistics-tab-maps" aria-selected="false" role="tab" tab="maps" href="#" data-navigo>
                                <!--begin::Icon-->
                                <div class="nav-icon mb-3">
                                    <i class="fad fa-map-signs fs-1 pe-0"></i>                                                      
                                </div>
                                <!--end::Icon-->
                                
                                <!--begin::Title-->
                                <span class="nav-text text-gray-800 fw-bold fs-7 lh-1" data-i18n="user.stats_maps">Maps</span>
                                <!--end::Title-->
                                
                                <!--begin::Bullet-->
                                <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                                <!--end::Bullet-->
                            </a>
                            <!--end::Link-->
                        </li>
                        <!--end::Item-->

                        <!--begin::Item-->
                        <li class="nav-item mb-3 me-3 me-lg-6" role="presentation">
                            <!--begin::Link-->
                            <a class="nav-link profile-stats-pill btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-85px pt-5 pb-2" id="kt_stats_widget_16_tab_link_3" data-bs-toggle="pill" data-bs-target="#profile-statistics-tab-bitches" aria-selected="false" role="tab" tab="bitches" href="#" data-navigo>
                                <!--begin::Icon-->
                                <div class="nav-icon mb-3">                                    
                                    <i class="fad fa-dog-leashed fs-1 pe-0"></i>
                                </div>
                                <!--end::Icon-->
                                
                                <!--begin::Title-->
                                <span class="nav-text text-gray-800 fw-bold fs-7 lh-1" data-i18n="user.stats_bitches">Bitches</span>
                                <!--end::Title-->
                                
                                <!--begin::Bullet-->
                                <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                                <!--end::Bullet-->
                            </a>
                            <!--end::Link-->
                        </li>
                        <!--end::Item-->
                        
                    </ul>

                    <div class="tab-content profile-statistics-tab-content w-100 mw-100 overflow-auto">
                                 
                        <!--begin::Tap pane-->
                        <div class="tab-pane fade" id="profile-statistics-tab-overall" role="tabpanel" aria-labelledby="#kt_stats_widget_16_tab_link_1">

                            <!--begin::Row-->
                            <div class="row">

                                <div class="col-12">
                                <!--begin::FAQ card-->
                                <div class="card card-flush pt-8">
                                    <div class="card-body pt-0 pb-4">
                                        <div class="text-uppercase mb-2 badge badge-primary text-gray-300 fs-7" data-i18n="user.substats_kstats">Kill Statistics</div>
                                        <!--begin::Table container-->
                                        <div class="table-responsive">
                                            <!--begin::Table-->
                                            <table class="table align-middle gs-0 gy-4">
                                                <!--begin::Table head-->
                                                <thead>
                                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                                        <th class="ps-4" style="border-top-left-radius: 0.475rem" data-toggle="tooltip" title="" data-i18n="[title]stats.tkills;[data-bs-original-title]stats.tkills">K</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tassists;[data-bs-original-title]stats.tassists">A</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tdeaths;[data-bs-original-title]stats.tdeaths">D</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.ths;[data-bs-original-title]stats.ths">Hs</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tsuicides;[data-bs-original-title]stats.tsuicides">S</th>
                                                        <th class="text-center border border-start-0 border-top-0 border-bottom-0" data-toggle="tooltip" title="" data-i18n="[title]stats.ttks;[data-bs-original-title]stats.ttks">TK</th>
                                                        <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tkdr;[data-bs-original-title]stats.tkdr">KDR</th>
                                                        <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tkpr;[data-bs-original-title]stats.tkpr">KPR</th>
                                                        <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tapk;[data-bs-original-title]stats.tapk">APK</th>
                                                        <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HSP</th>
                                                        <th class="text-primary text-nowrap text-end pe-4" style="border-top-right-radius: 0.475rem" data-toggle="tooltip" title="" data-i18n="[title]stats.thpk;[data-bs-original-title]stats.thpk">HPK</th>
                                                    </tr>
                                                </thead>
                                                <!--end::Table head-->

                                                <!--begin::Table body-->
                                                <tbody class="profile-stats-table-basic">                        
                                                    
                                                </tbody>
                                                <!--end::Table body-->
                                            </table>
                                            <!--end::Table-->
                                        </div>
                                        <!--end::Table container-->
                                    </div>

                                    <div class="card-body  pt-0 pb-4">
                                        <div class="text-uppercase mb-2 badge badge-primary text-gray-300 fs-7" data-i18n="user.substats_dmgstats">Damage & Accuracy Statistics</div>
                                        <!--begin::Table container-->
                                        <div class="table-responsive">
                                            <!--begin::Table-->
                                            <table class="table align-middle gs-0 gy-4">
                                                <!--begin::Table head-->
                                                <thead>
                                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                                        <th class="ps-4" style="border-top-left-radius: 0.475rem" data-toggle="tooltip" title="" data-i18n="[title]stats.tshots;[data-bs-original-title]stats.tshots;stats.shots">Shots</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tdamage;[data-bs-original-title]stats.tdamage;stats.damage">Dmg</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.thits;[data-bs-original-title]stats.thits;stats.hits">Hits</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.thead;[data-bs-original-title]stats.thead;stats.head">Head</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tbody;[data-bs-original-title]stats.tbody;stats.body">Body</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tarms;[data-bs-original-title]stats.tarms;stats.arms">Arms</th>
                                                        <th class="text-center border border-start-0 border-top-0 border-bottom-0" data-toggle="tooltip" title="" data-i18n="[title]stats.tlegs;[data-bs-original-title]stats.tlegs;stats.legs">Legs</th>
                                                        <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.taccuracy;[data-bs-original-title]stats.taccuracy;stats.accuracy">Acc</th>
                                                        <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tadr;[data-bs-original-title]stats.tadr;">ADR</th>
                                                        <th class="text-primary text-nowrap text-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.tspk;[data-bs-original-title]stats.tspk;" style="border-top-right-radius: 0.475rem">SPK</th>
                                                        
                                                    </tr>
                                                </thead>
                                                <!--end::Table head-->

                                                <!--begin::Table body-->
                                                <tbody class="profile-stats-table-damage">                        
                                                    
                                                </tbody>
                                                <!--end::Table body-->
                                            </table>
                                            <!--end::Table-->
                                        </div>
                                        <!--end::Table container-->
                                    </div>

                                    <div class="card-body  pt-0 pb-4">
                                        <!--begin::Table container-->
                                        <div class="text-uppercase mb-2 badge badge-primary text-gray-300 fs-7" data-i18n="user.substats_bombstats">Bombs Statistics</div>
                                        <div class="table-responsive">
                                            <!--begin::Table-->
                                            <table class="table align-middle gs-0 gy-4">
                                                <!--begin::Table head-->
                                                <thead>
                                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                                        <th class="ps-4" style="border-top-left-radius: 0.475rem" data-toggle="tooltip" title="" data-i18n="[title]stats.tbp;[data-bs-original-title]stats.tbp;">BP</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tbd;[data-bs-original-title]stats.tbd;">BD</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tbe;[data-bs-original-title]stats.tbe;">BE</th>
                                                        <th class="text-center">A Site</th>
                                                        <th class="text-center border border-start-0 border-top-0 border-bottom-0">B Site</th>                                                        
                                                        <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tbpm;[data-bs-original-title]stats.tbpm;">BPM</th>
                                                        <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tbdm;[data-bs-original-title]stats.tbdm;">BDM</th>
                                                        <th class="text-primary text-nowrap text-end pe-4" style="border-top-right-radius: 0.475rem" data-toggle="tooltip" title="" data-i18n="[title]stats.tbsep;[data-bs-original-title]stats.tbsep;">BSEP</th>
                                                    </tr>
                                                </thead>
                                                <!--end::Table head-->

                                                <!--begin::Table body-->
                                                <tbody class="profile-stats-table-bombs">                        
                                                    
                                                </tbody>
                                                <!--end::Table body-->
                                            </table>
                                            <!--end::Table-->
                                        </div>
                                        <!--end::Table container-->
                                    </div>

                                    <div class="card-body  pt-0 pb-4">
                                        <div class="text-uppercase mb-2 badge badge-primary text-gray-300 fs-7" data-i18n="user.substats_mkstats">Clutches & Multikill Statistics</div>
                                        <!--begin::Table container-->
                                        <div class="table-responsive">
                                            <!--begin::Table-->
                                            <table class="table align-middle gs-0 gy-4">
                                                <!--begin::Table head-->
                                                <thead>
                                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                                        <th class="ps-4" style="border-top-left-radius: 0.475rem" data-toggle="tooltip" title="" data-i18n="[title]stats.tk1;[data-bs-original-title]stats.tk1;">1K</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tk2;[data-bs-original-title]stats.tk2;">2K</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tk3;[data-bs-original-title]stats.tk3;">3K</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tk4;[data-bs-original-title]stats.tk4;">4K</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tk5;[data-bs-original-title]stats.tk5;">5K</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tclutches;[data-bs-original-title]stats.tclutches;">Clutches</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tv1;[data-bs-original-title]stats.tv1;">v1</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tv2;[data-bs-original-title]stats.tv2;">v2</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tv3;[data-bs-original-title]stats.tv3;">v3</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tv4;[data-bs-original-title]stats.tv4;">v4</th>
                                                        <th class="text-center border border-start-0 border-top-0 border-bottom-0" data-toggle="tooltip" title="" data-i18n="[title]stats.tv5;[data-bs-original-title]stats.tv5;">v5</th>
                                                        <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.cpm;[data-bs-original-title]stats.tcpm;">CPM</th>
                                                        <th class="text-primary text-nowrap text-end pe-4" style="border-top-right-radius: 0.475rem" data-toggle="tooltip" title="" data-i18n="[title]stats.tmkm;[data-bs-original-title]stats.tmkm;">MKM</th>
                                                    </tr>
                                                </thead>
                                                <!--end::Table head-->

                                                <!--begin::Table body-->
                                                <tbody class="profile-stats-table-clutches">                        
                                                    
                                                </tbody>
                                                <!--end::Table body-->
                                            </table>
                                            <!--end::Table-->
                                        </div>
                                        <!--end::Table container-->
                                    </div>


                                    <div class="card-body  pt-0 pb-4">
                                        <div class="text-uppercase mb-2 badge badge-primary text-gray-300 fs-7" data-i18n="user.substats_specialstats">Special Statistics</div>
                                        <!--begin::Table container-->
                                        <div class="table-responsive">
                                            <!--begin::Table-->
                                            <table class="table align-middle gs-0 gy-4">
                                                <!--begin::Table head-->
                                                <thead>
                                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                                        <th class="ps-4" style="border-top-left-radius: 0.475rem" data-toggle="tooltip" title="" data-i18n="[title]stats.tfk;[data-bs-original-title]stats.tfk;">FK</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tfd;[data-bs-original-title]stats.tfd;">FD</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tbk;[data-bs-original-title]stats.tbk;">BK</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tfa;[data-bs-original-title]stats.tfa;">FA</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tfv;[data-bs-original-title]stats.tfv;">FV</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tsk;[data-bs-original-title]stats.tsk;">SK</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.twb;[data-bs-original-title]stats.twb;">WB</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tqs;[data-bs-original-title]stats.tqs;">QS</th>
                                                        <th class="text-nowrap text-end pe-4" style="border-top-right-radius: 0.475rem" data-toggle="tooltip" title="" data-i18n="[title]stats.tns;[data-bs-original-title]stats.tns;">NS</th>
                                                    </tr>
                                                </thead>
                                                <!--end::Table head-->

                                                <!--begin::Table body-->
                                                <tbody class="profile-stats-table-special">                        
                                                    
                                                </tbody>
                                                <!--end::Table body-->
                                            </table>
                                            <!--end::Table-->
                                        </div>
                                        <!--end::Table container-->
                                    </div>

                                </div>                               
                                <!--end::FAQ card-->
                                </div>

                                <div class="col">
                                    <div class="card card-flush my-3 min-w-350px">
                                        <!--begin::Header-->
                                        <div class="card-header">
                                            <!--begin::Title-->
                                            <h4 class="card-title align-items-center flex-row">
                                                <span class="card-label fw-bold text-gray-800" data-i18n="user.substats_performance">Performance</span> <span class="text-gray-800" data-toggle="tooltip" title="This is an indication of how well you're doing in each skill group, use it to figure out which area needs improvement on your end. Your score is based on how you're doing compared to the benchmarks for each skill in that skill group. The score is capped at 100, which would correspond to you being above the benchmark in every skill of that skill group. All skills are included except Accuracy (All shots) and [CT] Smokes that stopped a push. All skills are weighted equally." data-i18n="[title]user.substats_performance_msg;[data-bs-original-title]user.substats_performance_msg"><i class="fad fa-question-circle fs-2"></i></span>                                    
                                            </h4>
                                            <!--end::Title-->
                                    
                                            <!--begin::Toolbar-->
                                            <div class="card-toolbar">                                          
                                            </div>
                                            <!--end::Toolbar-->
                                        </div>
                                        <!--end::Header-->
                                    
                                        <!--begin::Body-->
                                        <div class="card-body pt-0 pb-0 mb-n12">
                                            <div id="radar-stats" class="h-275px mt-n6" data-kt-chart-color="primary" style="">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="card card-flush my-3">
                                        <!--begin::Header-->
                                        <div class="card-header">
                                            <!--begin::Title-->
                                            <h4 class="card-title align-items-start flex-column">
                                                <span class="card-label fw-bold text-gray-800" data-i18n="stats.winrate">Win Rate</span>                                        
                                            </h4>
                                            <!--end::Title-->
                                    
                                            <!--begin::Toolbar-->
                                            <div class="card-toolbar">                                                
                                            </div>
                                            <!--end::Toolbar-->
                                        </div>
                                        <!--end::Header-->
                                    
                                        <!--begin::Body-->
                                        <div class="card-body pt-0 mb-6">
                                            <div class="d-flex align-items-center justify-content-center">
                                                <div class="flex-shrink-0 me-2">
                                                    <div class="w-150px min-h-auto ms-n3" id="radial-winrate" data-kt-chart-color="primary" style="/*width:180px;height: 180px*/"></div>
                                                </div>
                                                <div class="m-0">
                                                    <div class="card-body pt-5">                 
                                                        <!--begin::Item-->
                                                        <div class="d-flex flex-stack">
                                                            <!--begin::Section-->
                                                            <div class="text-gray-700 fw-semibold fs-6 me-10" data-i18n="stats.played">Played</div>                   
                                                            <!--end::Section-->  
                                            
                                                            <!--begin::Statistics--> 
                                                            <div class="d-flex align-items-senter">
                                                                <!--begin::Number-->           
                                                                <span class="text-gray-900 fw-bolder fs-6 wr-total">0</span> 
                                                                <!--end::Number--> 
                                                            </div>  
                                                            <!--end::Statistics-->           
                                                        </div>
                                                        <!--end::Item-->
                            
                                                        <!--begin::Separator-->
                                                        <div class="separator separator-dashed my-2"></div>
                                                        <!--end::Separator-->
                                         
                                                        <!--begin::Item-->
                                                        <div class="d-flex flex-stack">
                                                            <!--begin::Section-->
                                                            <div class="text-gray-700 fw-semibold fs-6 me-10"  data-i18n="stats.won">Won</div>                   
                                                            <!--end::Section-->  
                                            
                                                            <!--begin::Statistics--> 
                                                            <div class="d-flex align-items-senter">
                                                                <!--begin::Number-->
                                                                <span class="text-gray-900 fw-bolder fs-6 wr-win">0</span> 
                                                                <!--end::Number-->
                                                            </div>  
                                                            <!--end::Statistics-->
                                                        </div>
                                                        <!--end::Item-->
                            
                                                        <!--begin::Separator-->
                                                        <div class="separator separator-dashed my-2"></div>
                                                        <!--end::Separator-->
                                         
                                                        <!--begin::Item-->
                                                        <div class="d-flex flex-stack">
                                                            <!--begin::Section-->
                                                            <div class="text-gray-700 fw-semibold fs-6 me-10"  data-i18n="stats.lose">Lose</div>                   
                                                            <!--end::Section-->  
                                            
                                                            <!--begin::Statistics--> 
                                                            <div class="d-flex align-items-center">                  
                                                                <!--begin::Number-->           
                                                                <span class="text-gray-900 fw-bolder fs-6 wr-lose">0</span> 
                                                                <!--end::Number-->  
                                                            </div>  
                                                            <!--end::Statistics-->           
                                                        </div>
                                                        <!--end::Item-->
                                                        
                                                        <!--begin::Separator-->
                                                        <div class="separator separator-dashed my-2"></div>
                                                        <!--end::Separator-->
                                         
                                                        <!--begin::Item-->
                                                        <div class="d-flex flex-stack">
                                                            <!--begin::Section-->
                                                            <div class="text-gray-700 fw-semibold fs-6 me-10"  data-i18n="stats.drew">Drew</div>                   
                                                            <!--end::Section-->  
                                            
                                                            <!--begin::Statistics--> 
                                                            <div class="d-flex align-items-senter">
                                                                <!--begin::Number-->           
                                                                <span class="text-gray-900 fw-bolder fs-6 wr-tie">0</span> 
                                                                <!--end::Number-->   
                                                            </div>  
                                                            <!--end::Statistics-->           
                                                        </div>
                                                        <!--end::Item-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--end::Body-->
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="card card-flush my-3">
                                        <!--begin::Header-->
                                        <div class="card-header">
                                            <!--begin::Title-->
                                            <h4 class="card-title align-items-start flex-column">
                                                <span class="card-label fw-bold text-gray-800"  data-i18n="stats.hsp">HS Percent</span>
                                            </h4>
                                            <!--end::Title-->
                                    
                                            <!--begin::Toolbar-->
                                            <div class="card-toolbar">                                                
                                            </div>
                                            <!--end::Toolbar-->
                                        </div>
                                        <!--end::Header-->
                                    
                                        <!--begin::Body-->
                                        <div class="card-body pt-0">
                                            <div class="d-flex align-items-center justify-content-center">
                                                <div class="flex-shrink-0 me-2">
                                                    <div class="w-150px min-h-auto ms-n3" id="radial-hsp" data-kt-chart-color="primary" style="/*width:180px;height: 180px*/"></div>
                                                </div>
                                                <div class="m-0">
                                                    <div class="card-body pt-5">                 
                                                        <!--begin::Item-->
                                                        <div class="d-flex flex-stack">
                                                            <!--begin::Section-->
                                                            <div class="text-gray-700 fw-semibold fs-6 me-10" data-i18n="stats.kills">Kills</div>                   
                                                            <!--end::Section-->  
                                            
                                                            <!--begin::Statistics--> 
                                                            <div class="d-flex align-items-senter">
                                                                <!--begin::Number-->           
                                                                <span class="text-gray-900 fw-bolder fs-6 hsp-kills">0</span> 
                                                                <!--end::Number--> 
                                                            </div>  
                                                            <!--end::Statistics-->           
                                                        </div>
                                                        <!--end::Item-->
                            
                                                        <!--begin::Separator-->
                                                        <div class="separator separator-dashed my-2"></div>
                                                        <!--end::Separator-->
                                         
                                                        <!--begin::Item-->
                                                        <div class="d-flex flex-stack">
                                                            <!--begin::Section-->
                                                            <div class="text-gray-700 fw-semibold fs-6 me-10" data-i18n="stats.deaths">Deaths</div>                   
                                                            <!--end::Section-->  
                                            
                                                            <!--begin::Statistics--> 
                                                            <div class="d-flex align-items-senter">
                                                                <!--begin::Number-->
                                                                <span class="text-gray-900 fw-bolder fs-6 hsp-deaths">0</span> 
                                                                <!--end::Number-->
                                                            </div>  
                                                            <!--end::Statistics-->
                                                        </div>
                                                        <!--end::Item-->
                            
                                                        <!--begin::Separator-->
                                                        <div class="separator separator-dashed my-2"></div>
                                                        <!--end::Separator-->
                                         
                                                        <!--begin::Item-->
                                                        <div class="d-flex flex-stack">
                                                            <!--begin::Section-->
                                                            <div class="text-gray-700 fw-semibold fs-6 me-10" data-i18n="stats.hs">Headshots</div>                   
                                                            <!--end::Section-->  

                                                            <!--begin::Statistics--> 
                                                            <div class="d-flex align-items-center">                  
                                                                <!--begin::Number-->           
                                                                <span class="text-gray-900 fw-bolder fs-6 hsp-hs">0</span> 
                                                                <!--end::Number-->  
                                                            </div>  
                                                            <!--end::Statistics-->           
                                                        </div>
                                                        <!--end::Item-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--end::Body-->                                        
                                    </div>
                                </div>
                                
                                <div class="col">
                                    <div class="card card-flush my-3">
                                        <!--begin::Header-->
                                        <div class="card-header">
                                            <!--begin::Title-->
                                            <h4 class="card-title align-items-start flex-column">
                                                <span class="card-label fw-bold text-gray-800" data-toggle="tooltip" title="Average Damage per Round" data-i18n="[title]stats.tadr;[data-bs-original-title]stats.tadr">ADR</span>
                                            </h4>
                                            <!--end::Title-->
                                    
                                            <!--begin::Toolbar-->
                                            <div class="card-toolbar">                                                
                                            </div>
                                            <!--end::Toolbar-->
                                        </div>
                                        <!--end::Header-->
                                    
                                        <!--begin::Body-->
                                        <div class="card-body pt-0">
                                            <div class="d-flex align-items-center justify-content-center">
                                                <div class="flex-shrink-0 me-2">
                                                    <div class="w-150px min-h-auto ms-n3" id="radial-adr" data-kt-chart-color="primary" style="/*width:180px;height: 180px*/"></div>
                                                </div>
                                                <div class="m-0">
                                                    <div class="card-body pt-5">                 
                                                        <!--begin::Item-->
                                                        <div class="d-flex flex-stack">
                                                            <!--begin::Section-->
                                                            <div class="text-gray-700 fw-semibold fs-6 me-10" data-i18n="stats.damage">Damage</div>                   
                                                            <!--end::Section-->  
                                            
                                                            <!--begin::Statistics--> 
                                                            <div class="d-flex align-items-senter">
                                                                <!--begin::Number-->           
                                                                <span class="text-gray-900 fw-bolder fs-6 adr-damage">0</span> 
                                                                <!--end::Number--> 
                                                            </div>  
                                                            <!--end::Statistics-->           
                                                        </div>
                                                        <!--end::Item-->
                            
                                                        <!--begin::Separator-->
                                                        <div class="separator separator-dashed my-2"></div>
                                                        <!--end::Separator-->
                                         
                                                        <!--begin::Item-->
                                                        <div class="d-flex flex-stack">
                                                            <!--begin::Section-->
                                                            <div class="text-gray-700 fw-semibold fs-6 me-10" data-i18n="stats.rounds">Rounds</div>                   
                                                            <!--end::Section-->  
                                            
                                                            <!--begin::Statistics--> 
                                                            <div class="d-flex align-items-senter">
                                                                <!--begin::Number-->
                                                                <span class="text-gray-900 fw-bolder fs-6 adr-rounds">0</span> 
                                                                <!--end::Number-->
                                                            </div>  
                                                            <!--end::Statistics-->
                                                        </div>
                                                        <!--end::Item-->           
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--end::Body-->
                                    </div>
                                </div>
                            </div>
                            <!--end::Row-->
                        </div>
                        <!--end::Tap pane-->

                        <!--begin::Tap pane-->
                        <div class="tab-pane fade" id="profile-statistics-tab-weapons" role="tabpanel" aria-labelledby="#kt_stats_widget_16_tab_link_2">
                            
                                    <!--begin::FAQ card-->
                                    <div class="card card-flush pt-8">
                                        <div class="card-body pt-0 pb-4">
                                            <!--begin::Table container-->
                                            <div class="table-responsive">
                                                <!--begin::Table-->
                                                <table class="table table-custom align-middle gs-0 gy-4">
                                                    <!--begin::Table head-->
                                                    <thead>
                                                        <tr class="fw-bold text-gray-600 fs-7" style="background-color: #1b1b1b">
                                                        <th class="ps-4 rounded-start">Pos</th>
                                                        <th class="text-center" data-toggle="tooltip" title="" data-i18n="stats.weapon">Weapon</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tkills;[data-bs-original-title]stats.tkills">K</th>  
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tdeaths;[data-bs-original-title]stats.tdeaths">D</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.ths;[data-bs-original-title]stats.ths">HS</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HS%</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tfk;[data-bs-original-title]stats.tfk">FK</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tfd;[data-bs-original-title]stats.tfd;">FD</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.twb;[data-bs-original-title]stats.twb;">WB</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tqs;[data-bs-original-title]stats.tqs;">QS</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tns;[data-bs-original-title]stats.tns;">NS</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.thits;[data-bs-original-title]stats.thits;stats.hits">Hits</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tshots;[data-bs-original-title]stats.tshots;stats.shots">Shots</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tdamage;[data-bs-original-title]stats.tdamage;stats.damage">Dmg</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.taccuracy;[data-bs-original-title]stats.taccuracy;stats.accuracy">Acc</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.thead;[data-bs-original-title]stats.thead;stats.head">Head</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tchest;[data-bs-original-title]stats.tchest;stats.chest">Chest</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tstomach;[data-bs-original-title]stats.tstomach;stats.stomach">Stomach</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tlarm;[data-bs-original-title]stats.tlarm;stats.larm">Left Arm</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.trarm;[data-bs-original-title]stats.trarm;stats.rarm">Right Arm</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tlleg;[data-bs-original-title]stats.tlleg;stats.lleg">Left Leg</th>
                                                        <th class="text-nowrap text-end rounded-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.trleg;[data-bs-original-title]stats.trleg;stats.rleg">Right Leg</th>
                                                    </tr>
                                                    </thead>
                                                    <!--end::Table head-->

                                                    <!--begin::Table body-->
                                                    <tbody class="table-weapons-body">                        
                                                        
                                                    </tbody>
                                                    <!--end::Table body-->
                                                </table>
                                                <!--end::Table-->
                                            </div>
                                            <!--end::Table container-->
                                            
                                        </div>
                                    </div>
                            
                        </div>

                        <!--begin::Tap pane-->
                        <div class="tab-pane fade" id="profile-statistics-tab-maps" role="tabpanel" aria-labelledby="#kt_stats_widget_16_tab_link_3">
                            
                                    <!--begin::FAQ card-->
                                    <div class="card card-flush pt-8">
                                        <div class="card-body pt-0 pb-4">
                                            <!--begin::Table container-->
                                            <div class="table-responsive">
                                                <!--begin::Table-->
                                                <table class="table table-custom align-middle gs-0 gy-4">
                                                    <!--begin::Table head-->
                                                    <thead>
                                                        <tr class="fw-bold text-gray-600 fs-7" style="background-color: #1b1b1b">
                                                        <th class="ps-4 rounded-start">Pos</th>
                                                        <th class="text-center" data-i18n="stats.map">Map</th>                                                        
                                                        <th class="" data-i18n="stats.matches">Matches</th>  
                                                        <th class="text-primary" data-i18n="stats.winrate">Win Rate</th>
                                                        <th class="" data-i18n="stats.won">Win</th>
                                                        <th class="" data-i18n="stats.drew">Draw</th>
                                                        <th class="" data-i18n="stats.loss">Loss</th>
                                                        <th class="" data-i18n="stats.rounds">Rounds</th>
                                                        <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.trwp;[data-bs-original-title]stats.trwp;">RWP</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.trw;[data-bs-original-title]stats.trw;">RW</th>
                                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.trl;[data-bs-original-title]stats.trl;">RL</th>
                                                        <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.ttks;[data-bs-original-title]stats.tkdr">KDR</th>
                                                        <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tkpr;[data-bs-original-title]stats.tkpr">KPR</th>
                                                        <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tadr;[data-bs-original-title]stats.tadr">ADR</th>
                                                        <th class="text-nowrap text-primary text-end rounded-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HSP</th>
                                                    </thead>
                                                    <!--end::Table head-->

                                                    <!--begin::Table body-->
                                                    <tbody class="table-maps-body">                        
                                                        
                                                    </tbody>
                                                    <!--end::Table body-->
                                                </table>
                                                <!--end::Table-->
                                            </div>
                                            <!--end::Table container-->
                                            
                                        </div>
                                    </div>
                            
                        </div>


                        <!--begin::Tap pane-->
                        <div class="tab-pane fade" id="profile-statistics-tab-rating" role="tabpanel" aria-labelledby="#kt_stats_widget_16_tab_link_4">                            
                            <!--begin::FAQ card-->
                            <div class="card card-flush pt-8">
                                <div class="card-body pt-0 pb-4">
                                    <div class="text-uppercase mb-2 badge badge-primary text-gray-300 fs-7" data-i18n="user.substats_ratingev">Rating Evolution</div>
                                    <div id="chart-months"></div>
                                    <div id="chart-years"></div>
                                </div>
                            </div>
                            <!--end::FAQ card-->
                        </div>
                        <!--end::Tap pane-->

                        <!--begin::Tap pane-->
                        <div class="tab-pane fade" id="profile-statistics-tab-bitches" role="tabpanel" aria-labelledby="#kt_stats_widget_16_tab_link_5">
                            <!--begin::FAQ card-->
                            <div class="card card-flush pt-8">
                                <div class="card-body pt-0 pb-4">
                                    <!--begin::Table container-->
                                    <div class="table-responsive">
                                        <!--begin::Table-->
                                        <table class="table table-custom align-middle gs-0 gy-4">
                                            <!--begin::Table head-->
                                            <thead>
                                                <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                                    <th class="ps-4 rounded-start">Pos</th>                                        
                                                    <th class="text-center" data-i18n="stats.bitch_name">Bitch</th>
                                                    <th class="text-center" data-i18n="stats.kills">Kills</th>
                                                    <th class="text-center" data-i18n="stats.hs">HS</th>
                                                    <th class="text-center text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HSP</th>
                                                    <th class="text-center text-primary" data-i18n="stats.bk">Blind Kills</th>
                                                    <th class="text-center text-primary" data-i18n="stats.vf">Victims Flashed</th>
                                                    <th class="text-center text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.twb;[data-bs-original-title]stats.twb;stats.wb">Wallbangs</th>    
                                                    <th class="text-primary text-center pe-4 rounded-end" data-toggle="tooltip" title="" data-i18n="[title]stats.tsk;[data-bs-original-title]stats.tsk;stats.sk">Smoke Kills</th>
                                                </tr>
                                            </thead>
                                            <!--end::Table head-->

                                            <!--begin::Table body-->
                                            <tbody class="table-bitches-body">                            
                                                
                                            </tbody>
                                            <!--end::Table body-->
                                        </table>
                                        <!--end::Table-->
                                    </div>
                                    <!--end::Table container-->
                                    <div id="profile-bitches-loader" class="text-center">
                                        <div class="d-flex justify-content-center pt-10 pb-10">
                                            <div class="spinner-border text-primary text-center" role="status" style="width: 3rem; height: 3rem;">
                                                <span class="visually-hidden" data-i18n="example.loading">Loading...</span>
                                            </div>                                                       
                                        </div>
                                        <div class="pb-15 fw-semibold">
                                            <h3 class="text-gray-600 fs-5 mb-2" data-i18n="example.loading">Loading...</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--end::FAQ card-->
                        </div>
                        <!--end::Tap pane-->

                    </div>
                </div>


                
            </div>

            <div class="tab-pane main-tab fade" id="profile-tab-matches" role="tabpanel">
                <style>
                    .table-custom
                    {
                        border-collapse: separate;
                        border-spacing: 0 0.65rem;
                    }
                </style>
                <!--begin::FAQ card-->
                <div class="card card-flush">           
                    <div class="card-body py-8">
                        <!--begin::Table container-->
                        <div class="table-responsive">
                            <!--begin::Table-->
                            <table class="table table-custom align-middle gs-0 gy-4">
                                <!--begin::Table head-->
                                <thead>
                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">                                        
                                        <th class="ps-4 rounded-start">Map</th>
                                        <th class="" data-i18n="stats.score">Score</th>
                                        <th class="" data-i18n="stats.type">Type</th>
                                        <th class="" data-i18n="stats.mode">Mode</th>
                                        <th class="" data-i18n="stats.result">Result</th>
                                        <th class="" data-1i8n="stats.rank">Rank</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.trating;[data-bs-original-title]stats.trating;">Rating</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tkills;[data-bs-original-title]stats.tkills;">K</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tdeaths;[data-bs-original-title]stats.tdeaths;">D</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tassists;[data-bs-original-title]stats.tassists;">A</th>                                        
                                        <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.ttks;[data-bs-original-title]stats.tkdr">KDR</th>                                        
                                        <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tadr;[data-bs-original-title]stats.tadr">ADR</th>
                                        <th class="text-nowrap text-primary text-end rounded-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HSP</th>                                        
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tv1;[data-bs-original-title]stats.tv1;">v1</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tv2;[data-bs-original-title]stats.tv2;">v2</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tv3;[data-bs-original-title]stats.tv3;">v3</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tv4;[data-bs-original-title]stats.tv4;">v4</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tv5;[data-bs-original-title]stats.tv5;">v5</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tk3;[data-bs-original-title]stats.tk3;">3K</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tk4;[data-bs-original-title]stats.tk4;">4K</th>
                                        <th class="pe-4 rounded-end" data-toggle="tooltip" title="" data-i18n="[title]stats.tk5;[data-bs-original-title]stats.tk5;">5K</th>
                                    </tr>
                                </thead>
                                <!--end::Table head-->
 
                                <!--begin::Table body-->
                                <tbody class="table-matches-body">                            
                                    
                                </tbody>
                                <!--end::Table body-->
                            </table>
                            <!--end::Table-->
                        </div>
                        <!--end::Table container-->
                    </div>            

                    <div id="profile-matches-loader" class="text-center">
                        <div class="d-flex justify-content-center pt-10 pb-10">
                            <div class="spinner-border text-primary text-center" role="status" style="width: 3rem; height: 3rem;">
                                <span class="visually-hidden" data-i18n="example.loading">Loading...</span>
                            </div>                                                       
                        </div>
                        <div class="pb-15 fw-semibold">
                            <h3 class="text-gray-600 fs-5 mb-2" data-i18n="example.loading">Loading...</h3>
                        </div>
                    </div>
                </div>
                <!--end::FAQ card-->
            </div>
            <div class="tab-pane main-tab fade" id="profile-tab-friends" role="tabpanel">
                <div class="row g-6 mb-6 g-xl-9 mb-xl-9 profile-friends-list">
                    
                </div>
                <div id="profile-friends-loader" class="text-center">
                    <div class="d-flex justify-content-center pt-10 pb-10">
                        <div class="spinner-border text-primary text-center" role="status" style="width: 3rem; height: 3rem;">
                            <span class="visually-hidden" data-i18n="example.loading">Loading...</span>
                        </div>                                                       
                    </div>
                    <div class="pb-15 fw-semibold">
                        <h3 class="text-gray-600 fs-5 mb-2" data-i18n="example.loading">Loading...</h3>
                    </div>
                </div>
            </div>
            <div class="tab-pane main-tab fade" id="profile-tab-achievements" role="tabpanel">
                <div class="row">                    
                    <div class="col-12">
                        <div class="text-center">
                            <!--begin::Icon-->
                            <div class="pt-15 pb-6">
                                <i class="fad fa-construction fs-3x text-primary opacity-75"></i>
                            </div>
                            <!--end::Icon-->
                            <!--begin::Message-->
                            <div class="fw-bold pb-15">
                                <h3 class="text-gray-600 fs-5 mb-2">Under developing</h3>
                                <div class="text-muted fs-7">Section will be available soon</div>
                            </div>
                            <!--end::Message-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane main-tab fade" id="profile-tab-bans" role="tabpanel">
                <!--begin::FAQ card-->
                <div class="card card-flush">           
                    <div class="card-body py-8">
                        <!--begin::Table container-->
                        <div class="table-responsive">
                            <!--begin::Table-->
                            <table class="table table-custom align-middle gs-0 gy-4">
                                <!--begin::Table head-->
                                <thead>
                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">                                        
                                        <th class="ps-4 rounded-start" data-i18n="bans.reason">Reason</th>
                                        <th class="" data-i18n="bans.igname">In-game nickname</th>
                                        <th class="" data-i18n="bans.date">Date</th>
                                        <th class="pe-4 rounded-end"  data-i18n="bans.until">Until</th>
                                    </tr>
                                </thead>
                                <!--end::Table head-->
 
                                <!--begin::Table body-->
                                <tbody class="table-bans-body">
                                    <tr class="d-none user-nobans">
                                        <td colspan="4" class="text-center">
                                            
                                                    <div class="text-center">
                                                        <!--begin::Icon-->
                                                        <div class="pt-15 pb-6">
                                                            <i class="fad fa-smile-wink fs-3x text-primary opacity-75"></i>                                                            
                                                        </div>
                                                        <!--end::Icon-->
                                                        <!--begin::Message-->
                                                        <div class="fw-bold pb-15">
                                                            <h3 class="text-gray-600 fs-5 mb-2"  data-i18n="user.no_bans">No bans found</h3>
                                                            <div class="text-muted fs-7"  data-i18n="user.no_bans_msg">This user has never been banned</div>
                                                        </div>
                                                        <!--end::Message-->
                                                    </div>
                                            
                                        </td>
                                    </tr>
                                </tbody>
                                <!--end::Table body-->
                            </table>
                            <!--end::Table-->
                        </div>
                        <!--end::Table container-->
                    </div>                    
                </div>
                <!--end::FAQ card-->
            </div>
        </div>
    </div>
    <!--end::Row-->
</div>
<!--end::Container-->				
					




`;


export default view;